"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'oatFiArchitect1.maximumSingleBusiness',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit maximumSingleBusiness`);
            const concentrationLimitValueType = valueConfig.valueType;
            const groupingId = 'org_id';
            (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields[groupingId])), new common_1.error.FinleyError(`baseFields.${groupingId} must be defined to run oatFiArchitect1.maximumSingleBusiness`));
            const groupedByDebtorId = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingId]);
            const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.entries(groupedByDebtorId), ([debtorId, receivables]) => {
                // specific waivers to increase limits for certain debtors
                // camel case it to reduce edge cases
                let concentrationLimit;
                if (lodash_1.default.camelCase(debtorId) === lodash_1.default.camelCase('TITAN SOLAR POWER CA, INC.')) {
                    concentrationLimit = 1000000;
                }
                else {
                    // default to the value in the concentration limit config
                    concentrationLimit = valueConfig.limit;
                }
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map